import React from 'react'

const ProductRfqQuoteLayout = () => {
  return (
    <div>
      <h1>ProductRfqQuoteLayout</h1>
    </div>
  )
}

export default ProductRfqQuoteLayout
